import * as Types from '../../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type PictureCreationPictureFragment = { __typename: 'Picture', id: string, legacyId: number };

export type PictureCreationCreatePictureMutationVariables = Types.Exact<{
  input: Types.MutationCreatePictureInput;
}>;


export type PictureCreationCreatePictureMutation = { __typename: 'Mutation', createPicture: { __typename: 'Picture', id: string, legacyId: number } };

export type PictureCreationGetDefaultProjectQueryVariables = Types.Exact<{
  organizationId: Types.Scalars['ID']['input'];
}>;


export type PictureCreationGetDefaultProjectQuery = { __typename: 'Query', organization: { __typename: 'Organization', projects: Array<{ __typename: 'Project', id: string, sets: Array<{ __typename: 'Set', id: string }> }> } };

export type PictureCreationCreateProjectMutationVariables = Types.Exact<{
  input: Types.MutationCreateProjectInput;
}>;


export type PictureCreationCreateProjectMutation = { __typename: 'Mutation', createProject: { __typename: 'Project', id: string, name: string } };

export type PictureCreationCreateSetMutationVariables = Types.Exact<{
  input: Types.MutationCreateSetInput;
}>;


export type PictureCreationCreateSetMutation = { __typename: 'Mutation', createSet: { __typename: 'Set', id: string, name: string } };

export const PictureCreationPictureFragmentDoc = gql`
    fragment PictureCreationPicture on Picture {
  id
  legacyId
}
    `;
export const PictureCreationCreatePictureDocument = gql`
    mutation pictureCreationCreatePicture($input: MutationCreatePictureInput!) {
  createPicture(input: $input) {
    ...PictureCreationPicture
  }
}
    ${PictureCreationPictureFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PictureCreationCreatePictureGQL extends Apollo.Mutation<PictureCreationCreatePictureMutation, PictureCreationCreatePictureMutationVariables> {
    override document = PictureCreationCreatePictureDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PictureCreationGetDefaultProjectDocument = gql`
    query pictureCreationGetDefaultProject($organizationId: ID!) {
  organization(id: $organizationId) {
    projects(take: 1, orderBy: [{key: number, direction: asc}]) {
      id
      sets(take: 1, orderBy: [{key: number, direction: asc}]) {
        id
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PictureCreationGetDefaultProjectGQL extends Apollo.Query<PictureCreationGetDefaultProjectQuery, PictureCreationGetDefaultProjectQueryVariables> {
    override document = PictureCreationGetDefaultProjectDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PictureCreationCreateProjectDocument = gql`
    mutation pictureCreationCreateProject($input: MutationCreateProjectInput!) {
  createProject(input: $input) {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PictureCreationCreateProjectGQL extends Apollo.Mutation<PictureCreationCreateProjectMutation, PictureCreationCreateProjectMutationVariables> {
    override document = PictureCreationCreateProjectDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PictureCreationCreateSetDocument = gql`
    mutation pictureCreationCreateSet($input: MutationCreateSetInput!) {
  createSet(input: $input) {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PictureCreationCreateSetGQL extends Apollo.Mutation<PictureCreationCreateSetMutation, PictureCreationCreateSetMutationVariables> {
    override document = PictureCreationCreateSetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }